import VariantModel from 'coreClasses/product/VariantModel';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventSource, EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import ProductItemEvent from './common/ProductItemEvent';

/**
 * Represents AddToWishlistEvent
 */
export default class AddToWishlistEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const eventSourceCategoryId: string = data.eventSourceCategoryId;
		const eventSourceCategoryName: string = data.eventSourceCategoryName;
		const product: VariantModel = data.productData.product;
		const position = data.productData.position;
		const productCategoriesIds: string[] = data.productData.productCategoriesIds;
		const source = EAnalyticsEventSource[EEventSource[data.source]];
		const productItem = new ProductItemEvent({
			product,
			source,
			eventSourceCategoryId,
			eventSourceCategoryName,
			productCategoriesIds,
			index: position,
		});
		productItem.item_id = product.getVariationGroupId(product.getProductId());
		productItem.variation_id = product.getProductId();

		this.event = EAnalyticsEventType.ADD_TO_WISHLIST;
		this.event_trigger = 'ecomm';
		this.ecommerce = {
			currency: product.getPriceCurrency(),
			value: product.getPrice().value,
			items: [{...productItem}],
		};
	}
}
